import { useVehicleValidationSchema } from "./schemas/vehicle-validation-schemas.hook";
import { useAccidentValidationSchema } from "./schemas/accident-validation-schema.hook";
import * as Yup from "yup";
import { VehicleType } from "src/types";

export const useValidationSchemas = (): Yup.AnyObjectSchema[] => {
  const vehicleAValidationSchema: Yup.AnyObjectSchema = Yup.object({
    vehicleA: useVehicleValidationSchema({
      vehicleType: VehicleType.VEHICLE_A,
    }),
  });

  const vehicleBValidationSchema: Yup.AnyObjectSchema = Yup.object({
    vehicleB: useVehicleValidationSchema({
      vehicleType: VehicleType.VEHICLE_B,
    }),
  });

  const accidentValidationSchema: Yup.AnyObjectSchema = Yup.object({
    accidentData: useAccidentValidationSchema(),
  });

  return [
    vehicleAValidationSchema,
    vehicleBValidationSchema,
    accidentValidationSchema,
  ];
};
